export default "__VITE_ASSET__DRhlEuC___"